
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      tournaments: null,
      networkError: false
    };
  },
  methods: {
    refresh: function () {
      var self = this;
      setTimeout(function () {
        self.load(false);
      }, 1400);
    },
    load: function (background) {
      var self = this;
      this.$root.api('app/client_tournaments?live=true', {}, 'GET', function (data, status, xhr) {
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message, 'Ошибка');
        }
        if (data.status == 'ok') {
          self.tournaments = [];
          for (var i = 0; i < data.live.tournaments.length; i++) {
            var live = data.live.tournaments[i];
            data.live.tournaments[i].type = 'tournament';
            self.tournaments.push(live);
          }
          data.live.duels.map(t => {
            t.type = 'duel';
          });
          self.$root.prepareDuels(data.live.duels);
          for (var i = 0; i < data.live.duels.length; i++) {
            var live = data.live.duels[i];
            self.tournaments.push(live);
          }
          self.$root.sortTournaments(self.tournaments);
          self.$setState({ tournaments: self.tournaments });
          if (self.tournaments.length > 0) {
            self.$root.setLiveBadge(self.tournaments.length);
          }
          self.$app.ptr.done(self.$el.find('.ptr-content'));
        }
      }, true, {});
    }
  },
  on: {
    pageInit: function () {
      if (this.$route.query.noload) {
        this.$root.removeNoLoadFromUrl(this.$router);
      } else {
        this.load();
      }
    }
  },
  id: '77cd2582f5',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page">\n        <div class="navbar">\n            <div class="navbar-inner">\n                <div class="title">Лайв</div>\n            </div>\n        </div>\n        <div class="page-content ptr-content" @ptr:refresh="refresh">\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.networkError, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="ptr-preloader">\n                    <div class="preloader"></div>\n                    <div class="ptr-arrow"></div>\n                </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.networkError, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                ';
          r += Template7Helpers._partial.call(ctx_2, 'network-error', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.tournaments, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.tournaments, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.tournaments.length', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.tournaments, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.type==\'tournament\'', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                ';
                          r += Template7Helpers._partial.call(ctx_6, 'game-item', {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                            ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                ';
                          r += Template7Helpers._partial.call(ctx_6, 'duel-item', {
                            hash: {},
                            data: data_6 || {},
                            fn: function empty() {
                              return '';
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                            ';
                          return r;
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                    ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="live-empty">\n                          <div class="live-empty-image"><span class="image-no-live"></span></div>\n                          <div class="live-empty-top">Игры не начались</div>\n                          <div class="live-empty-bottom">События еще не начались</div>\n                        </div>\n                    ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n\n                    <div class="block block-strong text-align-center">\n                        <div class="preloader"></div>\n                    </div>\n                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `

    .live-empty {
        /*padding-top: 138px;*/
    }
    .live-empty-image{
        text-align: center;
        height: 100px;
    }
    .live-empty-top{
        font-size: 24px;
        text-align: center;
        color: #818E95;
    }
    .live-empty-bottom{
        font-size: 16px;
        text-align: center;
        color: #ACB4BE;
    }
    .image-no-live{
        width: 100px;
        height: 100px;
        display: inline-block;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M28.3287 41.6759C28.3287 42.5966 29.0748 43.3426 29.9955 43.3426C30.9154 43.3426 31.6615 42.5966 31.6615 41.6759V35.0104H36.6609C43.0999 35.0028 48.3183 29.7851 48.3251 23.3454V21.6794C48.3251 20.7587 47.5791 20.0127 46.6592 20.0127H13.331C12.4111 20.0127 11.665 20.7587 11.665 21.6794V23.3454C11.6719 29.7851 16.8903 35.0028 23.3292 35.0104H28.3287V41.6759ZM14.9978 23.3454H44.9924C44.9871 27.9452 41.26 31.6723 36.6609 31.6777H23.3292C18.7302 31.6723 15.0031 27.9452 14.9978 23.3454Z' fill='%23D0D6DA'/%3E%3Cpath d='M99.5023 62.8397C99.5023 62.7962 99.4657 62.7627 99.4558 62.7192C98.8181 59.1828 97.5777 55.7814 95.7897 52.6645C95.7752 52.6104 95.7569 52.5577 95.7363 52.5059C95.6936 52.4509 95.647 52.3983 95.5975 52.3495C93.7926 49.2723 91.4836 46.5201 88.7657 44.2095C88.7344 44.1652 88.7008 44.1225 88.6658 44.0829C88.6375 44.0592 88.6002 44.0539 88.5704 44.0325C85.8105 41.7342 82.6792 39.9232 79.3106 38.6768C79.2572 38.6409 79.2015 38.6081 79.1435 38.5799C79.084 38.5677 79.0245 38.5578 78.9635 38.5517C72.0867 36.0436 64.5448 36.0436 57.6673 38.5517C57.607 38.5578 57.5467 38.5677 57.4872 38.5799C57.4293 38.6081 57.3736 38.6409 57.3209 38.6768C54.362 39.7768 51.5853 41.3131 49.0818 43.2361C47.6523 41.9119 46.0206 40.8226 44.2493 40.0102C50.7821 37.036 54.9799 30.5238 54.9913 23.3458V13.3475C57.7519 13.3475 59.99 11.1094 59.99 8.34806V5.01532C59.99 2.2547 57.7519 0.0166016 54.9913 0.0166016H4.99949C2.2381 0.0166016 0 2.2547 0 5.01532V8.34806C0 11.1094 2.2381 13.3475 4.99949 13.3475V23.3458C5.01017 30.5231 9.20565 37.0345 15.7376 40.0102C9.20565 42.9852 5.01017 49.4966 4.99949 56.6739V66.6721C2.2381 66.6721 0 68.9102 0 71.6716V75.0043C0 77.7649 2.2381 80.003 4.99949 80.003H38.915C39.465 81.383 40.1103 82.7225 40.848 84.0109C40.8625 84.065 40.8808 84.1177 40.9014 84.1695C40.9601 84.2626 41.0272 84.3495 41.1035 84.4289C42.8984 87.4641 45.1853 90.1805 47.8704 92.4659C47.9017 92.5101 47.9345 92.5529 47.9704 92.5925C48.0024 92.6192 48.0405 92.6276 48.0741 92.6513C50.8355 94.9458 53.9661 96.7552 57.3339 98.0001C57.3873 98.036 57.443 98.0688 57.501 98.097C57.5689 98.1145 57.6375 98.1267 57.7069 98.1336C64.5684 100.631 72.0898 100.631 78.9505 98.1336C79.02 98.1267 79.0894 98.1145 79.1573 98.097C79.2145 98.0688 79.2702 98.036 79.3236 98.0001C82.6906 96.7567 85.822 94.9504 88.5841 92.6581C88.6169 92.6345 88.6558 92.6261 88.6871 92.5994C88.723 92.559 88.7565 92.517 88.787 92.4728C91.4722 90.1866 93.7591 87.471 95.5547 84.4357C95.6302 84.3564 95.6974 84.2695 95.7561 84.1756C95.7767 84.1245 95.795 84.0711 95.8095 84.0177C97.593 80.9039 98.8295 77.5079 99.4657 73.976C99.4848 73.9326 99.5015 73.8883 99.5153 73.8425C99.5252 73.7861 99.5153 73.7342 99.5153 73.6763C100.161 70.1505 100.161 66.5363 99.5153 63.0113C99.4939 62.9496 99.5122 62.8977 99.5023 62.8397ZM3.33274 8.34806V5.01532C3.33274 4.09537 4.07877 3.34934 4.99949 3.34934H54.9913C55.9113 3.34934 56.6573 4.09537 56.6573 5.01532V8.34806C56.6573 9.26878 55.9113 10.0148 54.9913 10.0148H4.99949C4.07877 10.0148 3.33274 9.26878 3.33274 8.34806ZM8.33222 56.6739C8.34138 48.3943 15.0503 41.6853 23.3292 41.6762C24.2499 41.6762 24.9959 40.9302 24.9959 40.0102C24.9959 39.0895 24.2499 38.3434 23.3292 38.3434C15.0503 38.3343 8.34138 31.6253 8.33222 23.3458V13.3475H51.6586V23.3458C51.6487 31.6253 44.9397 38.3343 36.6609 38.3434C35.7402 38.3434 34.9941 39.0895 34.9941 40.0102C34.9941 40.9302 35.7402 41.6762 36.6609 41.6762C40.2995 41.6846 43.8115 43.0126 46.5454 45.414C44.3989 47.4583 42.5483 49.7933 41.0463 52.3495C41.002 52.3953 40.9609 52.4425 40.922 52.4929C39.5657 51.9543 38.1201 51.6767 36.6609 51.6744H31.6614V48.3417C31.6614 47.4217 30.9153 46.6757 29.9954 46.6757C29.0747 46.6757 28.3286 47.4217 28.3286 48.3417V51.6744H23.3292C16.8902 51.682 11.6718 56.9004 11.665 63.3394V66.6721H8.33222V56.6739ZM14.9977 66.6721V63.3394C15.003 58.7403 18.7302 55.0132 23.3292 55.0071H36.6609C37.5984 55.0125 38.5275 55.1757 39.4101 55.4923C38.381 57.8036 37.635 60.2309 37.1887 62.7215C37.1788 62.7642 37.1506 62.7978 37.1422 62.8412C37.1338 62.8847 37.1422 62.9496 37.1422 63.0075C36.9378 64.2212 36.8043 65.4447 36.7425 66.6736L14.9977 66.6721ZM4.99949 76.6703C4.07877 76.6703 3.33274 75.9243 3.33274 75.0043V71.6716C3.33274 70.7509 4.07877 70.0048 4.99949 70.0048H36.7455C36.8073 71.2337 36.9408 72.458 37.1453 73.6709C37.1453 73.7258 37.1323 73.7777 37.1453 73.838C37.1598 73.883 37.1765 73.9272 37.1956 73.9707C37.3619 74.8876 37.5701 75.7854 37.8135 76.6718L4.99949 76.6703ZM87.7504 88.9005L86.8495 87.8272C86.4742 87.3474 85.867 87.1102 85.2659 87.2093C84.6648 87.3077 84.1651 87.7273 83.9638 88.3017C83.7624 88.8769 83.8905 89.5153 84.2979 89.9684L85.1957 91.0394C83.4496 92.3522 81.5578 93.4576 79.557 94.334L79.0673 92.9892C78.872 92.4186 78.3838 91.9983 77.7903 91.89C77.1968 91.7817 76.5919 92.0021 76.2067 92.4659C75.8222 92.9305 75.7185 93.5666 75.9359 94.1296L76.4256 95.4744C74.3302 96.0916 72.1699 96.463 69.9882 96.582V95.1754C69.9882 94.2555 69.2422 93.5094 68.3223 93.5094C67.4015 93.5094 66.6555 94.2555 66.6555 95.1754V96.582C64.4746 96.463 62.3143 96.09 60.2181 95.4721L60.7086 94.1273C60.926 93.5651 60.8223 92.9289 60.437 92.4644C60.0526 91.9998 59.4469 91.7794 58.8542 91.8884C58.2607 91.9968 57.7725 92.4171 57.5772 92.9877L57.0875 94.3325C55.0867 93.456 53.1949 92.3515 51.448 91.0394L52.3466 89.9684C52.7761 89.5191 52.9195 88.8677 52.7189 88.2788C52.5183 87.6907 52.0064 87.2627 51.3916 87.1697C50.7768 87.0759 50.1612 87.3329 49.795 87.8356L48.8934 88.9081C47.3037 87.4122 45.8902 85.7386 44.6826 83.9193L45.9138 83.2091C46.7041 82.7461 46.9726 81.7316 46.5141 80.939C46.0565 80.1457 45.0442 79.8703 44.2478 80.3234L43.0266 81.0267C42.0448 79.0762 41.2934 77.0181 40.7885 74.8945L42.1814 74.6488C42.768 74.5459 43.2546 74.1378 43.4583 73.5779C43.662 73.0187 43.5521 72.3932 43.1692 71.937C42.7863 71.4801 42.1898 71.2627 41.6031 71.3664L40.1965 71.6144C39.9257 69.4449 39.9257 67.2495 40.1965 65.0793L41.6031 65.3272C41.6993 65.344 41.7969 65.3524 41.8945 65.3524C42.7588 65.3517 43.4797 64.6911 43.5544 63.8298C43.6284 62.9686 43.0327 62.1936 42.1814 62.0449L40.7885 61.7992C41.2934 59.6756 42.0448 57.6175 43.0266 55.667L44.2478 56.3703C44.7635 56.6731 45.402 56.6754 45.9207 56.3779C46.4394 56.0804 46.7582 55.5274 46.7567 54.9293C46.756 54.3313 46.4341 53.7798 45.9138 53.4846L44.6826 52.7744C45.8902 50.9551 47.3037 49.2814 48.8934 47.7856L49.795 48.8581C50.1703 49.3379 50.7775 49.5751 51.3786 49.476C51.9797 49.3776 52.4786 48.9588 52.6807 48.3836C52.8821 47.8085 52.754 47.17 52.3466 46.7169L51.448 45.6459C53.1941 44.3308 55.0867 43.2224 57.0875 42.3429L57.5772 43.6877C57.7725 44.2583 58.2607 44.6786 58.8542 44.7869C59.4469 44.896 60.0526 44.6756 60.437 44.211C60.8223 43.7465 60.926 43.1103 60.7086 42.5481L60.2181 41.2032C62.3143 40.5854 64.4746 40.2139 66.6555 40.0949V41.5099C66.6555 42.4298 67.4015 43.1759 68.3223 43.1759C69.2422 43.1759 69.9882 42.4298 69.9882 41.5099V40.1033C72.1699 40.2223 74.3302 40.5953 76.4256 41.2132L75.9359 42.558C75.7185 43.1202 75.8222 43.7564 76.2067 44.2209C76.5919 44.6855 77.1968 44.9059 77.7903 44.7969C78.3838 44.6885 78.872 44.2682 79.0673 43.6976L79.557 42.3528C81.5578 43.2293 83.4496 44.3338 85.1957 45.6459L84.2979 46.7169C83.8905 47.17 83.7624 47.8085 83.9638 48.3836C84.1651 48.9588 84.6648 49.3776 85.2659 49.476C85.867 49.5751 86.4742 49.3379 86.8495 48.8581L87.7504 47.7856C89.3408 49.2814 90.7543 50.9551 91.9619 52.7744L90.7299 53.4846C90.2105 53.7798 89.8885 54.3313 89.887 54.9293C89.8863 55.5274 90.2051 56.0804 90.7238 56.3779C91.2425 56.6754 91.881 56.6731 92.3967 56.3703L93.618 55.667C94.5997 57.6175 95.3511 59.6756 95.856 61.7992L94.4631 62.0449C93.6118 62.1936 93.0153 62.9686 93.0901 63.8298C93.1648 64.6911 93.8849 65.3517 94.7492 65.3524C94.8476 65.3524 94.9445 65.344 95.0414 65.3272L96.4472 65.0793C96.7188 67.2495 96.7188 69.4449 96.4472 71.6144L95.0414 71.3664C94.4548 71.2627 93.8575 71.4801 93.4753 71.937C93.0924 72.3932 92.9825 73.0187 93.1862 73.5779C93.3899 74.1378 93.8765 74.5459 94.4631 74.6488L95.856 74.8945C95.3511 77.0181 94.5997 79.0762 93.618 81.0267L92.3967 80.3234C91.881 80.0206 91.2425 80.0183 90.7238 80.3158C90.2051 80.6133 89.8863 81.1663 89.887 81.7644C89.8885 82.3624 90.2105 82.9139 90.7299 83.2091L91.9619 83.9193C90.7536 85.7356 89.3408 87.4069 87.7504 88.9005Z' fill='%23D0D6DA'/%3E%3Cpath d='M84.1092 66.672H72.831C72.3413 65.3561 71.3038 64.3187 69.988 63.829V47.8152C69.988 46.8945 69.2419 46.1484 68.322 46.1484C67.4013 46.1484 66.6552 46.8945 66.6552 47.8152V63.829C64.5621 64.5956 63.2691 66.6979 63.5292 68.9116C63.7893 71.1253 65.5347 72.8714 67.7484 73.1315C69.962 73.3916 72.0651 72.0979 72.831 70.0047H84.1092C85.0299 70.0047 85.7759 69.2587 85.7759 68.3387C85.7759 67.418 85.0299 66.672 84.1092 66.672ZM68.322 69.8384C67.4936 69.8384 66.8223 69.1664 66.8223 68.3387C66.8223 67.5103 67.4936 66.839 68.322 66.839C69.1504 66.839 69.8217 67.5103 69.8217 68.3387C69.8217 69.1664 69.1504 69.8384 68.322 69.8384Z' fill='%23D0D6DA'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='100' height='100' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    }

`,
  styleScoped: false
};
    